"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetFolderModels = void 0;
var AssetFolderModels;
(function (AssetFolderModels) {
    class AssetFolder {
        constructor(data) {
            this.id = data.id;
            this.name = data.name;
            this.externalId = data.externalId;
            this.folders = data.folders;
            this._raw = data._raw;
        }
    }
    AssetFolderModels.AssetFolder = AssetFolder;
})(AssetFolderModels = exports.AssetFolderModels || (exports.AssetFolderModels = {}));
//# sourceMappingURL=asset-folder.models.js.map